import { useState } from "react";
import { SaveSingleColorButton } from "./save-single-color-button";
import { useSaveSingleColor } from "../../save-single-color";
import {
  useSavedColors,
  useCmsSaveColor,
  useCmsDeleteColor,
} from "../../../js/api/my-saved-colors/get-saved-colors";

export function SaveButton() {
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);
  const { saveColorUrl, removeColorUrl, colorCode } = useSaveSingleColor();
  const { data, isLoading, isError } = useSavedColors();
  const isSaveFunctionalityReady = !isLoading && !isError;
  const saveCmsColorMutation = useCmsSaveColor();
  const deleteCmsColorMutation = useCmsDeleteColor();
  const savedColors = data?.items || [];
  const isColorSaved = savedColors.some(
    (color) => color?.colourCode === colorCode
  );
  const toggleClickHandler = () => {
    setIsSpinnerVisible(true);
    if (isColorSaved) {
      deleteCmsColorMutation.mutateAsync({
        url: removeColorUrl,
        successHandler: () => setIsSpinnerVisible(false),
        errorHandler: () => setIsSpinnerVisible(false),
      });
    } else {
      saveCmsColorMutation.mutateAsync({
        url: saveColorUrl,
        successHandler: () => setIsSpinnerVisible(false),
        errorHandler: () => setIsSpinnerVisible(false),
      });
    }
  };

  return (
    <div>
      {isSaveFunctionalityReady && (
        <SaveSingleColorButton
          isSaved={isColorSaved}
          isLoading={isSpinnerVisible}
          disabled={isSpinnerVisible}
          toggleClickHandler={toggleClickHandler}
        />
      )}
    </div>
  );
}
